import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const KioskButton = styled(Button)(({ iconbgcolor }) => ({
    width: '100%',
    height: '70px',
    justifyContent: 'flex-start',
    padding: 0,
    backgroundColor: 'white',
    color: '#505050',
    textTransform: 'none',
    borderRadius: '5px',
    border: '1px solid #707070',
    textAlign: 'left',
    fontSize: 16,
    '&:hover': {
        backgroundColor: '#ccc',
        border: 'none',
    },
    '& .MuiButton-startIcon': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: iconbgcolor,
        marginLeft: 0,
        height: '100%',
        minWidth: 60,
        marginRight: 20,
        color: 'white',
        borderBottomLeftRadius: '4px',
        borderTopLeftRadius: '4px',
        '&:hover': {
            border: 'none',
        },
    },
    '& .MuiSvgIcon-root': {
        fontSize: 36,
    },
}));

export default KioskButton;
